import React from 'react';
import { Provider } from 'react-redux';

import Base from './Base.jsx';

import AssetList from '../Components/AssetList/index.jsx';

import Store from '../Store/index.js';


class EntryPoint extends Base {
  id() {
    return 'cs-asset-list';
  }

  renderElement(element) {
    // get show only rated asset attribute boolean value
    var showOnlyRatedAssetsFlag =  (element.dataset.id)? JSON.parse(element.dataset.id): false;
    return (
      <Provider store={Store}>
        <AssetList showOnlyRatedAssets = {showOnlyRatedAssetsFlag} />
      </Provider>
    );
  }
}


export default EntryPoint;

